import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Grid,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const AdvisoryAnswerDialogBox = ({ open, onClose, question, answer, date }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1" color="#000000">
              <span style={{ color: "#443F3F" }}>{t("Asked on : ")}</span>
              {new Date(date).toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" color="#000000">
              <span style={{ color: "#443F3F" }}>{t("Question : ")}</span>
              {question}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ width: "100%", backgroundColor: "#A5A5A5" }} />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1" color="#000000">
              <span style={{ color: "#443F3F" }}>{t("Answer : ")}</span>{" "}
              {answer}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AdvisoryAnswerDialogBox;
